import {Table} from './table';
import {TableHeader} from './TableHeader';
import {TableHeaderColumn, TableHeaderTitle} from './TableHeaderColumn';
import {TableRows} from './TableRows';
import {TableRow} from './TableRow';
import {TableColumn} from './TableColumn';
import {TableColumns} from './TableColumns';
import {ClickableElement} from './ClickableElement';
import {ItalicElement} from './ItalicElement';
import {TableHeaderGrouping, TableGrouping} from './TableGrouping';
import {TableCell} from './TableCell';
Table.Header = TableHeader;
Table.HeaderColumn = TableHeaderColumn;
Table.HeaderColumn.Title = TableHeaderTitle;
Table.Rows = TableRows;
Table.Row = TableRow;
Table.Column = TableColumn;
Table.Column.Cell = TableCell;
Table.Column.Clickable = ClickableElement;
Table.Column.Italic = ItalicElement;
Table.HeaderGrouping = TableHeaderGrouping;
export {
	Table,
	TableHeader,
	TableHeaderColumn,
	TableHeaderTitle,
	TableRows,
	TableRow,
	TableColumn,
	TableColumns,
	TableHeaderGrouping,
	TableGrouping,
	ClickableElement,
	ItalicElement,
	TableCell,
};
